import { Client, IFrame, messageCallbackType } from '@stomp/stompjs';

class websocket {
    userId: string;
    token: string;
    brokerUrl: string;
    client?: Client;

    constructor(userId: string, token: string, brokerUrl: string) {
        this.userId = userId;
        this.token = token;
        this.brokerUrl = brokerUrl;
        this.client = undefined;
    }

    init(routingKey: string, callback: messageCallbackType) {
        const client = new Client();
        const config = {
            brokerURL: this.brokerUrl,
            connectHeaders: {
                login: this.userId + '-guest',
                passcode: this.token
            },
            reconnectDelay: 5000,
            heartbeatIncoming: 4000,
            heartbeatOutgoing: 4000,
            onConnect: function (_frame: IFrame) {
                client.subscribe(
                    `/exchange/websocket-lite/${routingKey + '-guest'}.*`,
                    callback
                );
            },
            logRawCommunication: true
        };
        client.configure(config);
        client.activate();
        this.client = client;
    }

    disconnect() {
        if (this.client) {
            this.client.deactivate({ force: true });
        }
    }
}

export default websocket;
